/**
 * ColorPickerGrid  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { ColorPickerTile, IColorPickerTileProps } from "./ColorPickerTile";
import { getColorUtils } from "./colorUtils";

export interface IColorPickerGridTileProps extends IColorPickerTileProps {
	selected?: boolean;
}

export const ColorPickerGridTile = React.memo<IColorPickerGridTileProps>(({ selected, ...props }) => {
	const colorUtils = getColorUtils(props.value);
	const baseClass = BEM("edt-color-picker-grid-tile", null, {
		selected,
		light: colorUtils.isLight(),
		dark: colorUtils.isDark()
	});

	return <ColorPickerTile className={baseClass.toClassName()} {...props} />;
});
